import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getByNumber(params) {
    return backofficeService.Api().get('/cspApi/sms/promotionByNumber', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   * @param {*} data.toNumber
   */
  addToBlackList(data) {
    console.log('data is :', data)
    return backofficeService.Api().post('/cspApi/sms/addToBlackList', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
